import { useLocale } from 'next-intl';
import { useRouter } from '@/navigation';
import styles from './streamer-slider.module.scss';
import { CdnImg } from '@/features/cdn-img';
import { convertCultureToRef } from '@/utils/common-util';

interface StreamerSliderProps {
	onClose: () => void;
}

const ACTIVITY_ASSET_LOCALE_LIST = ['beng', 'ch', 'cs', 'zhcn', 'en', 'id', 'jp', 'ko', 'th', 'vn', 'tr'];

export const StreamerSlider = ({
	onClose
}: StreamerSliderProps) => {
	const locale = useLocale();
	const router = useRouter();
	const shortLang = convertCultureToRef(locale ?? 'en-US', true);
	const lang = ACTIVITY_ASSET_LOCALE_LIST.includes(shortLang) ? (shortLang === 'zhcn' ? 'cs' : shortLang) : 'en';

	const handleClickButton = () => {
		router.push('/streamer', { locale });
		onClose();
	};

	return (
		<div className={styles.container}>
			<CdnImg
				src={`/images/promotion-activity-modal/streamer-slider/${lang}.png`}
				width={288}
				height={360}
				isGalaxyFolder={true}
			/>
			<div
				className={styles.button}
				onClick={handleClickButton}
			>
			</div>
		</div>
	)
};